module.exports = __webpack_public_path__ + "static/media/MundoPak.44346f96.jpg";